import { Observable } from 'rxjs';
import { TpvMerchantOperationResult } from '@app/domain/models/tpv/merchant-operation.model';
import {
  CreateMerchantOperationRequest,
  UpdateMerchantOperationRequest,
} from '@app/data/dtos/tpv/merchant-operation.dto';

/**
 * Port del CRUD de datos de operación de un comercio (escritura; el GET viene
 * embebido en el detalle del comercio). `externalIdMerchant` (UUID) viaja en
 * la RUTA; el body NO lo lleva (§3).
 */
export abstract class MerchantOperationRepository {
  /** Lee el bloque de operación (404 si el comercio aún no lo tiene). */
  abstract getOperation(externalIdMerchant: string): Observable<TpvMerchantOperationResult>;

  abstract createOperation(
    externalIdMerchant: string,
    request: CreateMerchantOperationRequest,
    idempotencyKey?: string,
  ): Observable<TpvMerchantOperationResult>;

  /** PATCH parcial: solo los campos a cambiar. */
  abstract updateOperation(
    externalIdMerchant: string,
    request: UpdateMerchantOperationRequest,
    idempotencyKey?: string,
  ): Observable<TpvMerchantOperationResult>;

  /** Elimina el bloque de operación del comercio. */
  abstract deleteOperation(externalIdMerchant: string): Observable<void>;
}
